module.exports = __webpack_public_path__ + "static/media/ballot.a52256a3.svg";